export default function replaceShopifyCdnUrl(
    sourceURL: string,
    width?: number,
    height?: number
): string {
    if (!sourceURL) return sourceURL;

    let params = '';
    if (width || height) {
        const query = new URLSearchParams();
        if (width) query.append('width', width.toString());
        if (height) query.append('height', height.toString());
        params = query.toString() ? `?${query.toString()}` : '';
    }

    // Replace the Shopify CDN URL with the Bunny CDN URL
    return `${sourceURL.replace(
        'https://cdn.shopify.com/s/files/1',
        'https://maap-product-images.b-cdn.net/'
    )}${params}`;
}
